export default __webpack_public_path__ + "static/media/wrapper2-2880-dark.ef65be09.webp";